import React, { PropsWithChildren, useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import StyledLoader from 'Components/Loader';
import useQualityInitializer from 'hooks/useQualityInitializer';

import { useAppSelector } from 'hooks/index';
import { selectPartnerData } from 'store/partner/partnerSelector';
import LoadingPage from 'app/Pages/LoadingPage';
import useAuth from 'Modules/firebase/use-auth';
import { useSubdomain } from 'hooks/useSubdomain';
import { useOrgNavigate } from 'app/routes/useOrgNavigate';
import { ROUTES } from 'app/routes/constants';

const QualityAppLoader: React.FC<PropsWithChildren> = ({ children }) => {
    const { loading } = useQualityInitializer();
    const { isAppRoot } = useSubdomain();
    const navigate = useOrgNavigate();
    const { user, isAuthenticated } = useAuth();
    const organization = useAppSelector(selectPartnerData);
    const launchDarkly = useLDClient();

    useEffect(() => {
        if (!loading && organization && launchDarkly) {
            launchDarkly
                .identify({
                    kind: 'multi',
                    organizationId: { key: organization.id },
                    organization: { key: organization.name },
                })
                .catch((err) => {
                    console.error(
                        'Could not identify user for feature flags customization',
                        err,
                    );
                });
        }

        if (isAuthenticated && user && isAppRoot) {
            navigate(ROUTES.AUTH_LOGIN);
        }
    }, [launchDarkly, organization]);

    if (loading) {
        return (
            <LoadingPage container>
                <StyledLoader message="Getting everything ready for you" />
            </LoadingPage>
        );
    }

    return children;
};

export default QualityAppLoader;
